import React from "react";
import { Link } from "react-router-dom";
import { OnyxWordmark } from "./Brand";

const SERVICES = ["Multiline Railings", "Panel Railings", "Picket Railings"];

export const Footer = () => (
  <footer className="bg-onyx-black text-white/70 relative grain" data-testid="site-footer">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-24">
      <div className="grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <OnyxWordmark dark className="mb-8" />
          <p className="max-w-md text-2xl md:text-3xl font-display font-semibold text-white tracking-tight leading-snug">
            Architectural railings, engineered<br />and built with precision.
          </p>
          <Link to="/contact" className="inline-flex items-center gap-3 mt-8 text-sm tracking-[0.12em] uppercase text-onyx-wood hover:gap-5 transition-all">
            Start a project
            <span>&rarr;</span>
          </Link>
        </div>
        <div>
          <h4 className="text-[10px] tracking-[0.25em] uppercase text-white/40 mb-6">Services</h4>
          <ul className="space-y-3 text-sm">
            {SERVICES.map((s) => (
              <li key={s}><Link to="/services" className="hover:text-white transition-colors">{s}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-[10px] tracking-[0.25em] uppercase text-white/40 mb-6">Company</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
            <li><Link to="/projects" className="hover:text-white transition-colors">Projects</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            <li><Link to="/admin" className="hover:text-white transition-colors">Client Portal</Link></li>
          </ul>
        </div>
      </div>
      <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40">
        <span>&copy; {new Date().getFullYear()} ONYX CONTRACTING, LLC. All rights reserved.</span>
        <span className="tracking-[0.15em] uppercase">Precision · Engineering · Craftsmanship · Trust</span>
      </div>
    </div>
  </footer>
);

export default Footer;
